import { useMemo } from 'react';

import { useWorkloadLabelValuesQuery } from 'hooks/queries/cost';

import { makeWorkloadsGpuUtilizationSearchCriteria } from './searchCriteria';
import { useCostReportContext } from '../../../../../../../cost-report/hooks/useCostReportContext';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useSearchCriteria = () => {
  const { cluster } = useCluster();
  const { adjustedDateRange } = useCostReportContext();

  const { labelValues: workloadTypes } = useWorkloadLabelValuesQuery({
    label: 'workload_type',
    filter: {
      clusterIds: [cluster.id],
    },
    range: adjustedDateRange,
  });

  const { labelValues: workloadNames } = useWorkloadLabelValuesQuery({
    label: 'workload_name',
    filter: {
      clusterIds: [cluster.id],
    },
    range: adjustedDateRange,
  });

  return useMemo(
    () =>
      makeWorkloadsGpuUtilizationSearchCriteria({
        names: workloadNames,
        types: workloadTypes,
      }),
    [workloadNames, workloadTypes]
  );
};
